import { Fragment } from "react";
import { useLang } from "../../lib/i18n";
import { Reveal } from "./Reveal";

const VALUES = [["102", "mg", "Mg"], ["45", "mg", "K"], ["39", "mg", "Na"], ["335", "mg", "Cl"], ["70", "+", "∞"]];

export const Stats = () => {
  const { t } = useLang();
  return (
    <section className="border-b border-[#073B4C]/10 bg-[#FBF7EF]" data-testid="stats-section">
      <div className="mx-auto max-w-7xl px-5 py-12 md:px-10">
        <p className="mb-8 font-mono-x text-xs uppercase tracking-[0.22em] text-[#3F5F68]">{t.stats.per}</p>
        <div className="grid grid-cols-2 gap-y-8 sm:grid-cols-3 lg:grid-cols-5">
          {VALUES.map(([n, u, sym], i) => (
            <Reveal key={sym} delay={i * 0.08} className="border-l border-[#073B4C]/15 pl-5" >
              <p className="font-mono-x text-xs text-[#C2502F]">{sym}</p>
              <p className="font-display text-5xl leading-none text-[#073B4C] md:text-6xl" data-testid={`stat-${sym}`}>
                {n}<span className="ml-1 font-sans text-base text-[#3F5F68]">{u}</span>
              </p>
              <p className="mt-2 text-sm text-[#3F5F68]">{t.stats.items[i]}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Marquee = () => {
  const { t } = useLang();
  const row = (
    <div className="flex shrink-0 items-center">
      {t.marquee.map((m) => (
        <Fragment key={m}>
          <span className="px-8 font-display text-4xl italic text-[#073B4C] md:text-6xl">{m}</span>
          <svg viewBox="0 0 20 20" className="h-5 w-5 shrink-0 text-[#C2502F]" aria-hidden="true"><path d="M10 0 12 8 20 10 12 12 10 20 8 12 0 10 8 8Z" fill="currentColor" /></svg>
        </Fragment>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-b border-[#073B4C]/10 bg-[#E4F2EF] py-6 md:py-8" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">{row}{row}</div>
    </div>
  );
};
